import { FC, ReactNode, useMemo } from 'react';
import { KioskHomeContextProps, KioskHomeContext } from './kiosk-home.context';

interface KioskHomeMainProps extends KioskHomeContextProps {
  children: ReactNode;
}

const KioskHomeMain: FC<KioskHomeMainProps> = ({ children, locationId }) => {
  const contextValue = useMemo<KioskHomeContextProps>(() => ({ locationId: locationId || '' }), [locationId]);

  return <KioskHomeContext.Provider value={contextValue}>{children}</KioskHomeContext.Provider>;
};

export default KioskHomeMain;
